function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.523 0 10 4.477 10 10 0 5.522-4.477 10-10 10S0 15.522 0 10 4.477 0 10 0z",
  fill: "#05B8EE"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 9.73c1.38 0 2.5-1.156 2.5-2.88 0-1.723-.367-3.12-2.5-3.12-2.132 0-2.5 1.397-2.5 3.12 0 1.724 1.12 2.88 2.5 2.88zM15.494 14.903c-.054-3.346-.499-4.3-3.9-4.903 0 0-.478.6-1.594.6S8.406 10 8.406 10c-3.364.597-3.836 1.536-3.898 4.794-.005.266-.007.28-.008.25v.351s.81 2.062 5.5 2.062c4.69 0 5.5-2.062 5.5-2.062v-.26c0 .02-.003-.018-.006-.232z"
})))));